import { GoogleMapMarker, GoogleMapMarkerType, GoogleMapPopup } from '@lib/geo/google/map';
import { FsLvtCamera } from './lvt-camera';

export class SnLvtMarker extends GoogleMapMarker {
  public infoWindow: GoogleMapPopup;

  constructor(public readonly camera: FsLvtCamera) {
    super({
      id: `lvt-camera-${camera.id}`,
      type: GoogleMapMarkerType.CIRCLE,
      lonLat: camera.coordinates,
      title: camera.name,
    });

    this.setStyle({
      scale: 1,
      strokeOpacity: 0,
      fillOpacity: 0,
      rotation: 90,
    });
    this.setIcon(this._getIcon());
  }

  public setScale(scale: number): void {
    const style = this.style;

    this.setStyle({ ...style, scale });
  }

  private _getIcon(): any {
    return {
      url: '/assets/fusus-icons/PNG/lvt-circle-green.png',
      height: 32,
      width: 32,
      anchorY: 16,
      anchorX: 16,
    };
  }
}
